window.VAT_I18N = {
    de: {
        loading: "Wird geprüft...",
        incomplete: 'Bitte Firmenadresse vollständig ausfüllen.',

        vatInvalid: 'Die Umsatzsteuer-ID ist ungültig.',
        vatNotRegistered: 'Die USt-IdNr. ist nicht im EU-Register eingetragen.',
        vatNotYetValid: 'Die USt-IdNr. ist noch nicht gültig.',
        vatExpired: 'Die USt-IdNr. ist nicht mehr gültig.',
        vatInvalidFormat: 'Die USt-IdNr. hat ein ungültiges Format.',
        vatInvalidChecksum: 'Die Prüfziffer der USt-IdNr. ist ungültig.',
        vatInvalidChars: 'Die USt-IdNr. enthält unzulässige Zeichen.',
        vatInvalidCountry: 'Ungültiges Länderkennzeichen in der USt-IdNr.',
        vatCountryMismatch: 'Das ausgewählte Land passt nicht zur USt-IdNr.',
        vatNotAllowed: 'Diese USt-IdNr. darf nicht geprüft werden.',
        vatShopInvalid: 'Shop-USt-IdNr. ungültig.',
        vatMissingParams: 'Unvollständige Daten für die Prüfung.',
        vatInvalidRequest: 'Ungültige Prüfanfrage.',

        serviceDown: 'Der Dienst steht aktuell nicht zur Verfügung. Bitte versuchen Sie es später noch einmal.',
        vatServiceUnavailable: 'Der EU-Server ist derzeit nicht erreichbar.',
        vatServiceError: 'Die USt-IdNr.-Prüfung ist momentan nicht möglich.',
        unknownError: "Unbekannter Fehler. Bitte versuche Sie es päter noch einmal.",

        vatValidNotQualified: 'USt-IdNr. gültig, aber nicht qualifiziert bestätigt.',

        nameMismatch: 'Firmenname ist nicht korrekt.',
        streetMismatch: 'Straße ist nicht korrekt.',
        zipMismatch: 'Postleitzahl ist nicht korrekt.',
        cityMismatch: 'Ort ist nicht korrekt.',

        submitBlocked: 'Bitte schließen Sie die USt-IdNr.-Prüfung über den Button ab.',
        success: 'USt-IdNr. erfolgreich verifiziert.'
    },

    en: {
        loading: "Checking...",
        incomplete: 'Please complete the company address.',

        vatInvalid: 'The VAT ID is invalid.',
        vatNotRegistered: 'The VAT ID is not registered in the EU database.',
        vatNotYetValid: 'The VAT ID is not yet valid.',
        vatExpired: 'The VAT ID is no longer valid.',
        vatInvalidFormat: 'The VAT ID has an invalid format.',
        vatInvalidChecksum: 'The VAT ID checksum is invalid.',
        vatInvalidChars: 'The VAT ID contains invalid characters.',
        vatInvalidCountry: 'Invalid country code in VAT ID.',
        vatCountryMismatch: 'The selected country does not match the VAT ID.',
        vatNotAllowed: 'This VAT ID cannot be verified.',
        vatShopInvalid: 'Shop VAT ID is invalid.',
        vatMissingParams: 'Incomplete data for VAT verification.',
        vatInvalidRequest: 'Invalid verification request.',

        serviceDown: 'The service is currently unavailable. Please try again later.',
        vatServiceUnavailable: 'The EU VAT service is currently unavailable.',
        vatServiceError: 'VAT verification is currently not possible.',
        unknownError: "Unknown error. Please try again later.",

        vatValidNotQualified: 'VAT ID is valid but not qualified.',

        nameMismatch: 'Company name does not match.',
        streetMismatch: 'Street does not match.',
        zipMismatch: 'Postal code does not match.',
        cityMismatch: 'City does not match.',

        submitBlocked: 'Please complete the VAT ID check using the button.',
        success: 'VAT ID successfully verified.'
    },

    es: {
        loading: "De cheques...",
        incomplete: 'Por favor, complete la dirección de la empresa.',

        vatInvalid: 'El NIF-IVA no es válido.',
        vatNotRegistered: 'El NIF-IVA no está registrado en la base de datos de la UE.',
        vatNotYetValid: 'El NIF-IVA aún no es válido.',
        vatExpired: 'El NIF-IVA ya no es válido.',
        vatInvalidFormat: 'El formato del NIF-IVA no es válido.',
        vatInvalidChecksum: 'El dígito de control del NIF-IVA no es válido.',
        vatInvalidChars: 'El NIF-IVA contiene caracteres no válidos.',
        vatInvalidCountry: 'Código de país no válido en el NIF-IVA.',
        vatCountryMismatch: 'El país seleccionado no coincide con el NIF-IVA.',
        vatNotAllowed: 'Este NIF-IVA no puede ser verificado.',
        vatShopInvalid: 'El NIF-IVA de la tienda no es válido.',
        vatMissingParams: 'Datos incompletos para la verificación.',
        vatInvalidRequest: 'Solicitud de verificación no válida.',

        serviceDown: 'Este servicio no está disponible actualmente. Inténtelo de nuevo más tarde.',
        vatServiceUnavailable: 'El servicio de verificación de IVA no está disponible.',
        vatServiceError: 'No es posible verificar el IVA en este momento.',
        unknownError: "Error desconocido. Inténtalo de nuevo más tarde.",

        vatValidNotQualified: 'El NIF-IVA es válido pero no está verificado cualificadamente.',

        nameMismatch: 'El nombre de la empresa no coincide.',
        streetMismatch: 'La calle no coincide.',
        zipMismatch: 'El código postal no coincide.',
        cityMismatch: 'La ciudad no coincide.',

        submitBlocked: 'Por favor, complete la verificación del NIF-IVA usando el botón.',
        success: 'NIF-IVA verificado correctamente.'
    }
};
